/**
 * The noun to pair with a count. Singular only at exactly one, so zero reads "0 devices" rather
 * than "0 device", which is what the older `count > 1` checks produced.
 *
 * Pass `pluralForm` for any noun the regular `s` suffix gets wrong.
 */
export function plural(count: number, singular: string, pluralForm = `${singular}s`): string {
	return count === 1 ? singular : pluralForm
}
